import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FeatureToggleService } from '@farmnet/fnx-components';

const LOCALSTORAGE_KEY = '365farmnet.discontinued.claas';
const FEATURETOGGLE = 'hide-news-365-becomes-claas';
@Component({
  selector: 'app-news-popup',
  templateUrl: './newsPopup.component.html',
  styleUrls: ['./newsPopup.component.scss'],
})
export class NewsPopupComponent implements OnInit {
  @Input()
  userSettings: any;

  @Input()
  countryCode: any;

  urls = {
    de:
      'https://www.365farmnet.com/de/',
    en: 'https://www.365farmnet.com/en/',
    pl:
      'https://www.365farmnet.com/pl/',
    fr:
      'https://www.365farmnet.com/fr/',
  };

  close = new EventEmitter();

  url: string = this.urls.en;
  imgSource: string = 'assets/images/pop-up-image-en.jpg';
  checked: boolean = false;
  open: boolean = false;

  checkFn = (e) => {
    this.checked = e.target.checked;
  };

  getUrl = () => {
    return this.urls[this.userSettings?.uiLanguage] ?? this.urls.en;
  };

  getImgSource = () => {
    switch (this.userSettings?.uiLanguage) {
      case 'de':
        return 'assets/images/pop-up-image-de.jpg';
      case 'en':
        return 'assets/images/pop-up-image-en.jpg';
      case 'pl':
        return 'assets/images/pop-up-image-pl.jpg';
      case 'fr':
        return 'assets/images/pop-up-image-fr.jpg';
      default:
        return 'assets/images/pop-up-image-en.jpg';
    }
  }

  ngOnInit(): void {
    this.close.subscribe(() => {
      window.localStorage.setItem(LOCALSTORAGE_KEY, String(this.checked));
    });

    const localStorageValue = window.localStorage.getItem(LOCALSTORAGE_KEY);

    if (
      this.countryCode === 'CHE' ||
      this.featureToggleService.isFeatureActivated(FEATURETOGGLE)
    ) {
      this.open = false;
    } else if (localStorageValue != null) {
      this.open = localStorageValue.toLowerCase() !== 'true';
    } else {
      this.open = true;
    }

    this.url = this.getUrl();

    this.imgSource = this.getImgSource();
  }

  constructor(private featureToggleService: FeatureToggleService) {}
}
